<template>
	<div class="select-all">
		<p class="select-all__text">
			<span class="select-all__verbose">All</span>
			{{ selectedItems }}
			<span class="select-all__verbose"> elements on this page are </span
			>selected.
		</p>
		<div class="select-all__link">
			<a class="link" tabindex="0">
				Select all &nbsp;<span class="link__highlight">{{
					totalItems.toLocaleString()
				}}</span>
				&nbsp;elements.
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SelectAll',
	// Dev: for testing purposes only
	props: {
		selectedItems: {
			type: Number,
			default: 10
		},
		totalItems: {
			type: Number,
			default: 999999
		}
	}
};
</script>

<style lang="scss" scoped>
.select-all {
	width: 100%;
	background: $select-all-bkgd;
	padding: $padding-sm;
	text-align: center;
	font-size: $table-font-size;

	.select-all__text {
		display: inline-block;
		font-size: inherit;

		.select-all__verbose {
			display: none;
		}
	}
	.select-all__link {
		display: inline-block;
		margin-left: 4px;

		.link__highlight {
			font-weight: $medium-font-weight;
		}
	}
}

@include mq($from: md) {
	.select-all .select-all__text {
		.select-all__verbose {
			display: inline;
		}
	}
}
</style>
